import { useCallback, useEffect } from "react";
import userSessionData from "../services/userSessionData";

export const useSessionData = (sessionId) => {
  useEffect(() => {
    let active = true;
    if (sessionId) {
      userSessionData.load({ expectedSessionId: sessionId, isActive: () => active }).catch(() => {});
    }
    return () => {
      active = false;
    };
  }, [sessionId]);

  return useCallback(() => {
    // The loader publishes the error state consumed by the route guard.
    return userSessionData.load({ expectedSessionId: sessionId }).catch(() => {});
  }, [sessionId]);
};
